
export default function actionAsObjectMiddleware(config = {}) {
  return next => action => {
    if ( typeof action.type === "object" ){
      next({...action, type:action.type.__BASE})
    }
    else
      next(action)
  };
}


// WEBPACK FOOTER //
// ./src/middleware/actionAsObject.js